/* --------------------------------------------------------------------------------------
   results.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class resultsService {
  /*@ngInject*/
  constructor (appService, dataService, printService, persistService, $q, $timeout) {
    this.appService = appService
    this.dataService = dataService
    this.printService = printService
    this.persistService = persistService
    this.$q = $q
    this.$timeout = $timeout
  }
  printReports() {
    return this.appService.selectedReportIds
      .reduce((p, id) => p.then(result => this.printReport(id)), Promise.resolve())
  }
  printReport(reportId) {
    return this.$timeout(angular.noop, 3000)
      .then(result => this.dataService.GenerateReport(this.appService.classId, this.appService.testId, reportId))
      .then(result => this.printService.submitPrint(result.ReportGuid))
  }
  emailReports() {
    return this.dataService.postSendEmailReports(this.appService.classId, this.appService.testId, this.appService.selectedReportIds)
  }
  sendReports(submitAction) {
    let actions = []

    if (submitAction == 'email' || submitAction == 'both')
      actions.push(this.emailReports())

    if (submitAction == 'print' || submitAction == 'both')
      actions.push(this.printReports())

    return actions.reduce((p, fn) => p.then(result => fn), Promise.resolve())
  }
  savePreferences(submitAction, selectedReportNames) {
    let userId = this.appService.user.user64
    const userPreferences = {
      user: userId,
      action: submitAction,
      reports: selectedReportNames.map(item => item.substring(0,3))
    }
    let preferencesList = this.getPreferencesList().filter(item => item.user != userId)
    preferencesList.push(userPreferences)
    this.persistService.setObject('resultsPreferences', preferencesList)
  }
  loadPreferences() {
    let userId = this.appService.user.user64
    let userPreferences = this.getPreferencesList().find(item => item.user == userId) //filter by user
    if (!userPreferences)
      userPreferences =  {}
    return userPreferences
  }
  getPreferencesList () {
    let results = this.persistService.getObject('resultsPreferences')
    if (!results)
      results = []
    return results
  }
}



// WEBPACK FOOTER //
// ./src/app/results/services/results.service.js